import React,{useState,useEffect} from 'react'
import {useForm} from 'react-hook-form'

function ClinicInfoForm({clinicInfo,updateInfo}) {
        const {register,handleSubmit,formState:{errors}} = useForm({
            defaultValues:clinicInfo
        })
     const onSubmit = (data) =>{
        updateInfo(data)
     }

    return ( 
  <>
    <form onSubmit={handleSubmit(onSubmit)}>
         <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Name
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("name")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Email
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("email")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Phone
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("phone")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Sms
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("sms")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
       
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Signature
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("signature")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Website
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("website")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Address (Street)
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("street")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                City
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("city")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Postal Code
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("postalCode")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Province
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("province")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="row mb-3">
            <label htmlFor="" className="col-lg-4 col-form-label required fw-semibold fs-6">
                Country
            </label>
            <div className="col-lg-8 fv-row fv-plugins-icon-container">
                <input type="text" {...register("country")} className="form-control form-control-lg form-control-solid" />
            </div>
        </div>
        <div className="d-flex justify-content-center">
            <button type="submit" className="btn btn-success me-3">Save</button>            
    
        </div>
       
    </form>
  </>
  )
}

export default ClinicInfoForm